import {
  Plane,
  Ship,
  Archive,
  Clock,
  Database,
} from "lucide-react";
import { Statistics } from "./type-model";
import { useEffect, useState } from "react";
import { fetchAirArchiveStats } from "./archieve-service";
import toast from "react-hot-toast";

function StatisticsCards() {
  const [airStatistics, setAirStatistics] = useState<Statistics>({
    totalArchived: 0,
    lastMonth: 0,
    avgDaysToArchive: 0,
  });

  const [oceanStatistics, setOceanStatistics] = useState<Statistics>({
    totalArchived: 0,
    lastMonth: 0,
    avgDaysToArchive: 0,
  });

  const loadAirStats = async () => {
    try {
      const data = await fetchAirArchiveStats("api/v1/archieve/air");
      setAirStatistics(data);
    } catch {
      toast.error("Failed to load air archive statistics");
    }
  };

  const loadOceanStats = async () => {
    try {
      const data = await fetchAirArchiveStats("api/v1/archieve/ocean");
      setOceanStatistics(data);
    } catch {
      toast.error("Failed to load ocean archive statistics");
    }
  };

  useEffect(() => {
    loadAirStats();
    loadOceanStats();
  }, []);

  return (
    <div className="oceanAirShipmentsArchieveMain">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">

        {/* Ocean Statistics */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-3 md:p-4 lg:p-5 oceanAirShipmentsArchieveOuter">
          <div className="flex gap-2 mb-4">
            <Ship style={{ color: "#F8B71F" }} className="w-5 h-5" />
            <h3
              style={{ color: "#333435" }}
              className="font-semibold"
            >
              Ocean Shipments
            </h3>
          </div>

          <div className="grid grid-cols-3 gap-1 sm:gap-2 lg:gap-4">
            {/* Total Archived */}
            <div className="flex flex-col items-center text-center">
              <div className="flex items-center gap-2 mb-1">
                <Database style={{ color: "#777779" }} className="w-4 h-4" />
                <span
                  style={{ color: "#777779" }}
                  className="text-xs font-medium"
                >
                  Total Archived
                </span>
              </div>
              <div
                style={{ color: "#333435" }}
                className="text-2xl font-bold"
              >
                {oceanStatistics.totalArchived.toLocaleString()}
              </div>
            </div>

            {/* Last 30 Days */}
            <div className="flex flex-col items-center text-center">
              <div className="flex items-center gap-2 mb-1">
                <Clock style={{ color: "#777779" }} className="w-4 h-4" />
                <span
                  style={{ color: "#777779" }}
                  className="text-xs font-medium"
                >
                  Last 30 Days
                </span>
              </div>
              <div
                style={{ color: "#333435" }}
                className="text-2xl font-bold"
              >
                {oceanStatistics.lastMonth}
              </div>
            </div>

            {/* Avg Days */}
            <div className="flex flex-col items-center text-center">
              <div className="flex items-center gap-2 mb-1">
                <Archive style={{ color: "#777779" }} className="w-4 h-4" />
                <span
                  style={{ color: "#777779" }}
                  className="text-xs font-medium"
                >
                  Avg. Days
                </span>
              </div>
              <div
                style={{ color: "#333435" }}
                className="text-2xl font-bold"
              >
                {Math.round(oceanStatistics.avgDaysToArchive)}
              </div>
            </div>
          </div>
        </div>

        {/* Air Statistics */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-3 md:p-4 lg:p-5 oceanAirShipmentsArchieveOuter">
          <div className="flex  gap-2 mb-4">
            <Plane style={{ color: "#F8B71F" }} className="w-5 h-5" />
            <h3
              style={{ color: "#333435" }}
              className="font-semibold"
            >
              Air Shipments
            </h3>
          </div>

          <div className="grid grid-cols-3 gap-1 sm:gap-2 lg:gap-4">
            {/* Total Archived */}
            <div className="flex flex-col items-center text-center">
              <div className="flex items-center gap-2 mb-1">
                <Database style={{ color: "#777779" }} className="w-4 h-4" />
                <span
                  style={{ color: "#777779" }}
                  className="text-xs font-medium"
                >
                  Total Archived
                </span>
              </div>
              <div
                style={{ color: "#333435" }}
                className="text-2xl font-bold"
              >
                {airStatistics.totalArchived.toLocaleString()}
              </div>
            </div>

            {/* Last 30 Days */}
            <div className="flex flex-col items-center text-center">
              <div className="flex items-center gap-2 mb-1">
                <Clock style={{ color: "#777779" }} className="w-4 h-4" />
                <span
                  style={{ color: "#777779" }}
                  className="text-xs font-medium"
                >
                  Last 30 Days
                </span>
              </div>
              <div
                style={{ color: "#333435" }}
                className="text-2xl font-bold"
              >
                {airStatistics.lastMonth}
              </div>
            </div>

            {/* Avg Days */}
            <div className="flex flex-col items-center text-center">
              <div className="flex items-center gap-2 mb-1">
                <Archive style={{ color: "#777779" }} className="w-4 h-4" />
                <span
                  style={{ color: "#777779" }}
                  className="text-xs font-medium"
                >
                  Avg. Days
                </span>
              </div>
              <div
                style={{ color: "#333435" }}
                className="text-2xl font-bold"
              >
                {Math.round(airStatistics.avgDaysToArchive)}
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}
export default StatisticsCards;